import { connectedStore } from '../../store';
import getBlock from '../selectors/block';
import getBlockIdByElement from './get-block-id-by-element';

const getBlockByElement = (element) => {
  if (!element || !element.id) return null;

  const store = connectedStore.get();
  const state = store.getState();

  const blockId = getBlockIdByElement(element);
  return getBlock(state, blockId);
};

export default getBlockByElement;
